import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab as MuiTab } from '@mui/material';
import { FunctionComponent, SyntheticEvent, useState } from 'react';

import { TabProps } from './Tab.types';

const Tab: FunctionComponent<TabProps> = (props: TabProps): JSX.Element => {
  /** States */
  const [tabValue, setTabValue] = useState('0');

  /** Props */
  const { labels, values, tabContextProps, tabPanelProps, tabListProps } =
    props;

  /** Handle Tab Change */
  const handleChange = (_event: SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <TabContext value={tabValue} {...tabContextProps}>
        <Box sx={{ borderBottom: 1, borderColor: 'text.disabled' }}>
          <TabList onChange={handleChange} {...tabListProps}>
            {labels?.map((value, index) => (
              <MuiTab
                key={index}
                label={value}
                value={`${index}`}
                sx={{
                  minWidth: '14rem',
                  p: 0.8,
                  color: 'text.disabled',
                }}
              />
            ))}
          </TabList>
        </Box>
        {values?.map((val, ind) => (
          <TabPanel
            key={ind}
            value={`${ind}`}
            sx={{ p: 0, pt: 2.4 }}
            {...tabPanelProps}
          >
            {val}
          </TabPanel>
        ))}
      </TabContext>
    </Box>
  );
};

Tab.defaultProps = {
  tabListProps: {
    textColor: 'secondary',
    indicatorColor: 'secondary',
  },
};

export default Tab;
